import PropTypes from 'prop-types';

import { matchPhrases } from '../../../utils/utilities';
import { getAffirmativeOptions } from '../../../utils/data';

import Joi from 'joi';
import Form from '../../common/form';

import toastService from '../../../services/toastService';

class CustomUTMEquipmentSummaryOverviewForm extends Form {
	state: any = {
		data: { hasAnomalies: '', equipmentNumber: '', overview: '' },
		errors: {},
		loading: false,
		touched: false,
		progress: 0,
	};

	schema = {
		hasAnomalies: Joi.string().min(2).required().label('Has Anomalies'),
		equipmentNumber: Joi.string().min(1).required().label('Equipment Tag'),
        overview: Joi.string().min(10).required().label('Overview'),
	};

    static propTypes = {
		initialSummary: PropTypes.object,
        onSave: PropTypes.func
    }

	componentDidMount(): void {
		if (this.props.initialSummary) {
			this.setState({ data: this.props.initialSummary });
		}
	}
	
    componentDidUpdate(prevProps: any, prevState: any) {
		if (this.props.initialSummary && this.props.initialSummary.hasAnomalies !== this.state.data.hasAnomalies) {
			if (prevState.data.equipmentNumber !== this.state.data.equipmentNumber && prevState.data.hasAnomalies !== this.state.data.hasAnomalies) {
				const data = { ...this.state.data };

				const prefix = matchPhrases(data.hasAnomalies, 'yes') ? 'Anomalies were noticed' : 'No anomalies were noticed';
				data.overview = `As per client request UTM /TML was done on Equipment Tag: ${this.state.data.equipmentNumber}.  ${prefix} (Refer details reports in below pages)`;
				
				this.setState({ data });
			}
		}
    }

	doSubmit = (): void => {
		this.props.onSave(this.state.data);
		toastService.success('Saved successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
                <div className="container">
                    <div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'equipmentNumber',
								placeholder: 'Enter Equipment Tag',
								label: 'Equipment Tag',
							})}
						</div>

                        <div className="col-6">
							{this.renderSelect({
								options: getAffirmativeOptions(),
								name: 'hasAnomalies',
								label: 'Has Anomalies',
								placeholder: 'Select Has Anomalies',
							})}
                        </div>
                    </div>

					<div className="my-4 divider"></div>

					 <div className="row">
						<div className="col">
							{this.renderTextEditor({
								name: 'overview',
								label: 'Overview',
								placeholder: 'Enter Overview',
							})}
						</div>
                    </div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Save')}
					</div>
                </div>
			</form>
		);
	}
}

export default CustomUTMEquipmentSummaryOverviewForm;
